import { ClientConfig } from '@sanity/client';
import { PropertyRef } from '@spotify-internal/remote-config-properties';

import { LineOfBusiness } from 'providers/messaging/types';

export enum Vertical {
  ARTISTS = 'artists',
  CONSUMER = 'consumer',
  PODCASTERS = 'podcasters',
}

export type VerticalConfig = {
  verticalName: Vertical;
  pathParam: string;
  cms: ClientConfig;
  features: FeatureConfig;
  locales: LocaleConfig;
  theme: `encore-${string}-theme`;
  rolloutConfig: null | {
    rolloutProperty: PropertyRef<boolean>;
    fallbackUrl: string;
  };
};

export type VerticalConfigs = Record<Vertical, VerticalConfig>;

export type MastheadVariants = 's4a';

export type PillowTalkConfig = {
  lineOfBusiness: LineOfBusiness;
  redirectUri: string;
};

export type FeatureConfig = {
  showHeaderGradient: boolean;
  configureMasthead: {
    header: MastheadVariants;
    footer: MastheadVariants;
  } | null;
  communityLink: string | null;
  configurePillowTalk: PillowTalkConfig | null;
  emailMessagingFallback: boolean;
};

type LocaleConfig = {
  smartling: Record<string, string>;
  englishSupportOnly: Readonly<Array<string>>;
};
